import { COLORS } from "../../globals/designSystem";

const variants = {
  white: {
    color: COLORS.white,
  },
  grey_0: {
    color: COLORS.grey_0,
  },
  grey: {
    color: COLORS.grey,
  },
  grey_6: {
    color: COLORS.grey_6,
  },
  grey_10: {
    color: COLORS.grey_10,
  },
  grey_30: {
    color: COLORS.grey_30,
  },
  grey_70: {
    color: COLORS.grey_70,
  },
  grey_80: {
    color: COLORS.grey_80,
  },
  grey_84: {
    color: COLORS.grey_84,
  },
  grey_90: {
    color: COLORS.grey_90,
  },
  grey_100: {
    color: COLORS.grey_100,
  },
  green_10: {
    color: COLORS.green_10,
  },
  green_60: {
    color: COLORS.green_60,
  },
  green_80: {
    color: COLORS.green_80,
  },
  sky: {
    color: COLORS.sky,
  },
  sky_20: {
    color: COLORS.sky_20,
  },
  sky_80: {
    color: COLORS.sky_80,
  },
  sky_90: {
    color: COLORS.sky_90,
  },
  sky_100: {
    color: COLORS.sky_100,
  },
  blue_80: {
    color: COLORS.blue_80,
  },
  blue_100: {
    color: COLORS.blue_100,
  },
  teal_80: {
    color: COLORS.teal_80,
  },
  red_80: {
    color: COLORS.red_80,
  },
  yellow_80: {
    color: COLORS.yellow_80,
  },
  purple: {
    color: COLORS.purple,
  },
  cyan_60: {
    color: COLORS.cyan_60,
  },
  yellow_30: {
    color: COLORS.yellow_30,
  },
  neutral_82: {
    color: COLORS.neutral_82,
  },
  neutral_60: {
    color: COLORS.neutral_60,
  },
  blue_50: {
    color: COLORS.blue_50,
  },
  neutral_30: {
    color: COLORS.neutral_30,
  },
  neutral_8: {
    color: COLORS.neutral_8,
  },
  neutral_400: {
    color: COLORS.neutral_400,
  },
  neutral_500: {
    color: COLORS.neutral_500,
  },
  neutral_600: {
    color: COLORS.neutral_600,
  },
  neutral_800: {
    color: "#1F2A37",
  },
  neutral_700: {
    color: "#384250",
  },
  neutral_900: {
    color: COLORS.neutral_900,
  },
  neutral_1000: {
    color: COLORS.neutral_1000,
  },
  blue_600: {
    color: COLORS.blue_600,
  },
  cyan_500: {
    color: COLORS.cyan_500,
  },
};

const linkVariants = {
  darkBg: {
    color: COLORS.sky_70,
    hoverColor: COLORS.sky,
  },
  lightBg: {
    color: COLORS.sky_80,
    hoverColor: COLORS.sky_90,
  },
  white: {
    color: COLORS.white,
    hoverColor: COLORS.white,
  },
  grey_100: {
    color: COLORS.grey_100,
    hoverColor: COLORS.grey_100,
  },
  grey_hover: {
    color: COLORS.grey_80,
    hoverColor: COLORS.grey_100,
  },
  blue_50: {
    color: COLORS.blue_50,
    hoverColor: COLORS.blue_50,
  },
  blue_500: {
    color: COLORS.blue_500,
    hoverColor: COLORS.blue_600,
  },
  blue_600: {
    color: COLORS.blue_600,
    hoverColor: COLORS.blue_700,
  },
};
const paddingBottoms = {
  pb0: {
    paddingBottom: "0px",
  },
  pb4: {
    paddingBottom: "4px",
  },
  pb8: {
    paddingBottom: "8px",
  },
  pb12: {
    paddingBottom: "12px",
  },
  pb16: {
    paddingBottom: "16px",
  },
  pb24: {
    paddingBottom: "24px",
  },
  pb32: {
    paddingBottom: "32px",
  },
  pb40: {
    paddingBottom: "40px",
  },
  pb48: {
    paddingBottom: "48px",
  },
  pb56: {
    paddingBottom: "56px",
  },
  pb64: {
    paddingBottom: "64px",
  },
};

const fontWeights = {
  font_normal: {
    fontWeight: "normal",
  },
  font_200: {
    fontWeight: "200",
  },
  font_300: {
    fontWeight: "300",
  },
  font_400: {
    fontWeight: "400",
  },
  font_500: {
    fontWeight: "500",
  },
  font_600: {
    fontWeight: "600",
  },
  font_bold: {
    fontWeight: "bold",
  },
};
const defaults = {
  variant: variants.grey_100,
  paddingBottom: paddingBottoms.pb0,
  fontWeight: fontWeights.font_normal,
  linkVariant: linkVariants.lightBg,
};

export { variants, paddingBottoms, fontWeights, defaults, linkVariants };
